import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

/**
 * Component to add canonical URL links
 * This helps prevent duplicate content issues for SEO
 */
const CanonicalLink = ({ path }) => {
  const location = useLocation();
  const baseUrl = 'https://codie.codes';
  
  // Use specified path or current path
  const canonicalPath = path || location.pathname;
  
  // Ensure we don't have double slashes
  const url = `${baseUrl}${canonicalPath === '/' ? '' : canonicalPath}`;
  
  return (
    <Helmet>
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default CanonicalLink; 